import React, { useEffect, useRef, useState } from "react";
import Nafdac from "../Images/Konn3ct Images/Nafdac.png";
import Chams from "../Images/Konn3ct Images/Chams.png";
import IntraHub from "../Images/Konn3ct Images/Intrahub.png";
import YouTube from "react-youtube";

const App3 = () => {
  const scrollRef = useRef(null);
  const scrollPosRef = useRef(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const autoScroll = () => {
      if (isHovered) return;

      scrollPosRef.current += 1; // scrolling speed

      const halfWidth = scrollContainer.scrollWidth / 2;

      // Seamless loop 👇
      if (scrollPosRef.current >= halfWidth) {
        scrollPosRef.current = 0;
        scrollContainer.scrollLeft = 0;
      } else {
        scrollContainer.scrollLeft = scrollPosRef.current;
      }
    };

    const interval = setInterval(autoScroll, 20); // speed control
    return () => clearInterval(interval);
  }, [isHovered]);

  //   useEffect(() => {
  //   const scrollContainer = scrollRef.current;
  //   if (!scrollContainer) return;

  //   const autoScroll = () => {
  //     if (isHovered) return; // pause when hovered

  //     scrollPosRef.current += 1;

  //     // Loop when reaching half of the duplicated width
  //     if (scrollPosRef.current >= scrollContainer.scrollWidth / 2) {
  //       scrollPosRef.current = 0;
  //     }

  //     scrollContainer.scrollLeft = scrollPosRef.current;
  //   };

  //   const interval = setInterval(autoScroll, 60);
  //   return () => clearInterval(interval);
  // }, [isHovered]);

  // useEffect(() => {
  //   const scrollContainer = scrollRef.current;
  //   let scrollAmount = 0;

  //   const autoScroll = () => {
  //     if (!scrollContainer || isHovered) return;
  //     scrollAmount += 1;
  //     if (scrollAmount >= scrollContainer.scrollWidth / 2) scrollAmount = 0;

  //     scrollContainer.scrollTo({
  //       left: scrollAmount,
  //       behavior: "smooth",
  //     });
  //   };

  //   const interval = setInterval(autoScroll, 50);
  //   return () => clearInterval(interval);
  // }, [isHovered]);

  const ceos = [
    {
      id: 1,
      logo: Nafdac,
      name: "Name name",
      position: "CEO, NAFDAC",
      text: "Lorem ipsum dolor sit amet consectetur. Tristique purus orci ultricies malesuada donec et amet blandit nullam…",
    },
    {
      id: 2,
      logo: Chams,
      name: "Name name",
      position: "CEO, CHAMS",
      text: "Lorem ipsum dolor sit amet consectetur. Tristique purus orci ultricies malesuada donec et amet blandit nullam…",
    },
    {
      id: 3,
      logo: IntraHub,
      name: "Name name",
      position: "CEO, INTRAHUB",
      text: "Lorem ipsum dolor sit amet consectetur. Tristique purus orci ultricies malesuada donec et amet blandit nullam…",
    },
    {
      id: 4,
      logo: Nafdac,
      name: "Another CEO",
      position: "CEO, Example",
      text: "Another sample message showing continuous scroll effect in the CEO blog section.",
    },
  ];

  const loopedCeos = [...ceos, ...ceos]; // invisible duplication

  const youtubeOptions = {
    width: "100%",
    height: "100%",
    playerVars: {
      autoplay: 1,
      mute: 1,
      controls: 1,
      rel: 0,
    },
  };

  return (
    <div className="relative z-10 w-full bg-white md:px-16 py-10 px-6">
      {/* ====== CEO TALK’S Section ====== */}
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-bold text-black">
          CEO TALK’S
        </h2>
        <p className="text-black mt-2">
          The story, the product, and the future we’re building with Konn3ct.
        </p>
        <div className="mt-8 mx-auto w-full max-w-4xl h-[300px] md:h-[400px] bg-gray-100 rounded-none border-2 border-purple-300 flex items-center justify-center">
          <YouTube
            videoId="_TmnP8PSCBk"
            opts={youtubeOptions}
            className="w-full h-full object-contain rounded-xl"
          />
        </div>
      </div>

      {/* ====== Testimonials Section ====== */}
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-black">
          Don’t just take it from us
        </h2>
        <p className="text-gray-600 mt-2">
          Loved by teams. Backed by awards. Trusted worldwide.
        </p>
      </div>

      {/* ====== Horizontal Auto-Scroll Section ====== */}
      <div
        ref={scrollRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="overflow-x-auto hide-scrollbar w-full"
      >
        <div className="flex gap-6 w-max px-4 py-6">
          {/* {ceos.map((ceo) => (
            <div
              key={ceo.id}
              className="bg-white shadow-md rounded-xl p-6 w-[280px] sm:w-[320px] flex-shrink-0 text-left border border-gray-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="mb-4">
                <img src={ceo.logo} alt="logo" className="h-10 w-12" />
              </div>
              <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                {ceo.text}
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full bg-gray-300"></div>
                <div>
                  <p className="font-semibold text-sm text-black">{ceo.name}</p>
                  <p className="text-gray-500 text-xs">{ceo.position}</p>
                </div>
              </div>
            </div>
          ))} */}

          {/* {loopedCeos.map((ceo, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-xl p-6 w-[280px] sm:w-[320px] flex-shrink-0 text-left border border-gray-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="mb-4">
                <img src={ceo.logo} alt="logo" className="h-10 w-12" />
              </div>
              <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                {ceo.text}
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full bg-gray-300"></div>
                <div>
                  <p className="font-semibold text-sm text-black">{ceo.name}</p>
                  <p className="text-gray-500 text-xs">{ceo.position}</p>
                </div>
              </div>
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
};

export default App3;
